export default "__VITE_ASSET__BC5M_Yga__"